import { vemetric } from "@vemetric/react";

declare const window: {
	sa_event: any;
};

const isBrowser = typeof document !== "undefined";

export function trackEvent(name: string, metadata?: any) {
	if (!isBrowser) {
		return;
	}

	try {
		if (window.sa_event) {
			window.sa_event(name, metadata);
		}

		let eventName = name;
		if (eventName == "send_tx" && metadata?.type) {
			eventName = metadata.type;
		}
		console.log(eventName, metadata);

		vemetric.trackEvent(eventName, {
			eventData: metadata,
		});
	} catch (e) {
		// ignore errors
	}
}

export function createTransactionSizeBucket(size: number): number {
	if (size <= 1) {
		return 0;
	}
	if (size <= 100) {
		return 100;
	}
	if (size <= 500) {
		return 500;
	}
	if (size <= 1000) {
		return 1000;
	}

	return Math.ceil(size / 1000) * 1000;
}
